import pageHeaderMediaQuery from './pageHeaderMedia';

export default `
    careersHeader {
        headerTitle {
            content
        }
        description
        ${pageHeaderMediaQuery}
    }
`;
